module.exports = __webpack_public_path__ + "static/media/09_after.8b5a2432.jpg";